import arimage from "../../../Assets/newIcons/arIcon.png";
import ModelPopUp from "../ModelPopUp";
import { useMediaHook } from "../useMediaHook";
const ArBtn = ({ activateAR, incrementSpaceClicks }) => {
  const isMdOrDown = useMediaHook();

  return (
    <>
      <button
        id="SDM_QR_TEXT"
        onClick={() => {
          incrementSpaceClicks();
          activateAR();
        }}
        style={{
          position: "absolute",
          bottom: isMdOrDown ? "5px" : "1.30rem",
          left: isMdOrDown ? "50%" : "50%",
          display: isMdOrDown ? "flex" : "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `1px 2px 5px rgba(0, 0, 0, 0.1)`,
          borderRadius: isMdOrDown ? "13px" : `10px`,
          // padding: "2rem",
          width: isMdOrDown ? "230px" : `245px`,
          height: isMdOrDown ? "58px" : "54.09px",
          transform: isMdOrDown ? "translateX(-50%)" : "translateX(-50%)",
          outline: "none",
          border: "none",
          border: "0px solid red",
        }}
        className="bgWhiteTopMost"
      >
        <img
          src={arimage}
          width={isMdOrDown ? 28 : 38}
          height={isMdOrDown ? 28 : 40}
          alt="ar image icon"
        />
        <div
          style={{
            marginLeft: "0.5rem",
            fontSize: isMdOrDown ? "18px" : "16px",
            fontWeight: isMdOrDown ? 500 : 500,
            wordWrap: "keep-all",
            color: "#2E2E2E",
            letterSpacing: -1,
          }}
        >
          {`View in your space`}
        </div>
      </button>
    </>
  );
};

export default ArBtn;
